import { getDiscountedYearlyUnitAmount } from '@/shared/constants/pricingDiscount';
import { PaymentInterval, PlanCategory, Price } from '@/shared/types/Billing';

export const getEffectivePriceUnitAmount = (category: PlanCategory | string, price: Price): number => {
  if (price.recurring?.interval !== PaymentInterval.Year || price.experiment_variant === 'D') {
    return price.unit_amount;
  }

  return getDiscountedYearlyUnitAmount(category, price.unit_amount);
};
